export default __webpack_public_path__ + "static/media/01-Maria-Shmatova.cf84a3a0.png";